'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSrcSet = function getSrcSet(src) {
  var _src$split = src.split('.png'),
      _src$split2 = _slicedToArray(_src$split, 1),
      imagePrefix = _src$split2[0];

  return '\n    ' + src + ' 1x,\n    ' + imagePrefix + '@2x.png 2x,\n    ' + imagePrefix + '@3x.png 3x\n  ';
};

var ResponsivePNG = function ResponsivePNG(props) {
  var style = props.style,
      styleOverrides = props.styleOverrides,
      className = props.className,
      src = props.src,
      alt = props.alt,
      width = props.width,
      height = props.height;

  var srcSet = src ? getSrcSet(src) : '';

  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement('img', {
      className: className,
      src: src,
      srcSet: srcSet,
      alt: alt,
      width: width,
      height: height,
      style: styleOverrides || null
    }),
    style && _react2.default.createElement(
      'style',
      { jsx: true },
      style
    )
  );
};

ResponsivePNG.propTypes = {
  src: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  style: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  styleOverrides: _propTypes2.default.shape({
    // eslint-disable-next-line react/forbid-prop-types
    style: _propTypes2.default.object
  }),
  alt: _propTypes2.default.string,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string
};

ResponsivePNG.defaultProps = {
  style: '',
  styleOverrides: null,
  alt: '',
  width: null,
  height: null,
  className: null
};

exports.default = ResponsivePNG;